import axios from 'axios'
import * as base from '@/api/endpoint/base'

export const getRequest = (url:string, json: any) => {
    const resp = axios({
        method: 'get',
        url: `${base.BaseMaster()}${url}` + base.getDefault(json), // ..,
        headers: {
            'Authorization': `Bearer ${base.token()}`
        }
    }).then((response) => {
        return response.data
    })
    return resp
}


export const getDownload = (url: string, json: any) => {
    const resp = axios({
        method: 'get',
        url: `${base.BaseMaster()}${url}` + base.getDefault(json), // ..,
        responseType: "arraybuffer",
        headers: {
            'Authorization': `Bearer ${base.token()}`,
            "Accept": "application/octet-stream",
        }
    }).then((response) => {
        return response.data
    })
    return resp
}
// Store ongoing requests to enable cancellation
const pendingRequests = new Map<string, AbortController>();

export const postRequest = (url: string, json: any) => {
    // Generate request key based on URL and JSON data
    const requestKey = `${url}-${JSON.stringify(json)}`;
    
    // Cancel previous pending request with same key
    if (pendingRequests.has(requestKey)) {
        pendingRequests.get(requestKey)?.abort();
        pendingRequests.delete(requestKey);
    }

    // Create new abort controller for this request
    const controller = new AbortController();
    pendingRequests.set(requestKey, controller);

    const resp = axios({
        method: 'post',
        url: `${base.BaseMaster()}${url}`,
        headers: {
            'Authorization': `Bearer ${base.token()}`
        },
        data: json,
        signal: controller.signal
    })
    .then((response) => {
        pendingRequests.delete(requestKey);
        return response.data;
    })
    .catch((error) => {
        pendingRequests.delete(requestKey);
        if (error.name === 'AbortError') {
            // Request was cancelled, suppress error
            return;
        }
        throw error;
    });

    return resp;
}





